/* tslint:disable */

/**
 * Collaborative documenting
 * Collaborative documenting Api specification
 *
 * OpenAPI spec version: 1.0.0
 * Contact: support@example.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export enum SourceEnum {
  FORM = "FORM",
  TAGETIK_FORM = "TAGETIK_FORM",
  EXCEL = "EXCEL",
}
